import WebStorageCache from 'web-storage-cache'
import { isEmpty } from '@/libs/utils';

const PREFIX_CACHE = "pc_";

const cache = new WebStorageCache({
    storage: "localStorage"
});

/**
 * 获取缓存内容
 * @param string name 
 * @returns any
 */
export const get = (name,defaults=null)=>{
    let array = name.split(".");
    let value = cache.get(PREFIX_CACHE + array[0] || "");
    
    if(isEmpty(value)){
        return defaults;
    }

    if(array[1] != undefined){
        return value[array[1]] || defaults;
    }
    
    return value;
}

/**
 * 
 * @param string name 
 * @param object defaults 
 * @returns 
 */
export const getJson = (name,defaults=null)=>{
    const string = get(name);
    if(isEmpty(string)){
        return defaults;
    }

    return JSON.parse(string);
}

/**
 * 设置缓存
 * @param string name 
 * @param string value 
 * @param object options 
 */
export const set = (name,value,options=null)=>{
    if(options == null){
        cache.set(PREFIX_CACHE + name,value);
    }else{
        cache.set(PREFIX_CACHE + name,value,options);
    }
}

export const setJson = (name,value,options=null)=>{
    set(name,JSON.stringify(value),options);
}

/**
 * 删除缓存
 * @param string name 
 */
export const remove = (name)=>{
    cache.delete(PREFIX_CACHE + name);
}

/**
 * 手工删除所有超时CacheItem
 */
export const deleteAllExpires = ()=>{
    cache.deleteAllExpires();
}
 
/**
 * 清除所有缓存
 */
export const clear = ()=>{
    cache.clear();
}

/**
 * 为已存在的（未超时的）缓存值设置新的超时时间
 * @param string name 
 * @param number exp 
 */
export const touch = (name,exp=1)=>{
    cache.touch(PREFIX_CACHE + name,exp);
}

/**
 * 如果缓存中没有key的缓存，则添加。反之什么都不做
 * @param string name 
 * @param object|json value 
 * @param object options 
 */
export const add = (name, value,options=null)=>{
    if(options == null){
        cache.add(PREFIX_CACHE + name, value);
    }else{
        cache.add(PREFIX_CACHE + name, value,options);
    }
}

/**
 * 如果缓存中有key的缓存，则替换为新值。反之什么都不做
 * @param string name 
 * @param string value 
 * @param object options 
 */
export const replace = (name, value,options=null)=>{
    if(options == null){
        cache.replace(PREFIX_CACHE + name, value);
    }else{
        cache.replace(PREFIX_CACHE + name, value,options);
    }
}

/**
 * 检查当前选择作为缓存的storage是否被用户浏览器支持
 */
export const isSupported = ()=>{
    cache.isSupported();
}
